import React from 'react';
import { lookbook } from '../mock/data';
import { useNotify } from './Notify';
import { Bell } from 'lucide-react';

const Lookbook = () => {
  const { open } = useNotify();
  return (
    <section id="lookbook" className="relative bg-[var(--paper)] border-t border-[var(--line)] py-24 md:py-32">
      <div className="max-frame container-px">
        <div className="text-center max-w-[760px] mx-auto">
          <p className="reveal text-[11px] uppercase tracking-kicker text-[var(--muted)]">The colorways</p>
          <h2 className="reveal mt-5 font-display uppercase font-tight text-[clamp(2.2rem,5vw,4.2rem)] leading-[0.95]">
            Four colors, <span className="text-[var(--accent)]">this Halloween</span>
          </h2>
          <p className="reveal mt-5 text-[var(--muted)] text-lg leading-relaxed">
            Heavyweight natural canvas, contrast trim, and the Purple Lotus emblem on every piece.
            Only 20 made in each color — delivery Oct 26, in-store + delivery Oct 30.
          </p>
        </div>

        {/* Singles */}
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-7 auto-rows-fr">
          {lookbook.singles.map((c) => (
            <figure key={c.name} className="reveal h-full flex flex-col rounded-[10px] overflow-hidden bg-white border border-[var(--line)]">
              <div
                className="aspect-square overflow-hidden flex items-center justify-center"
                style={{ background: `linear-gradient(180deg, ${c.dot}12, #ffffff 82%)` }}
              >
                <img src={c.src} alt={`${c.name} Lotus Tote`} className="h-full w-full object-contain p-3" />
              </div>
              <figcaption className="mt-auto flex items-center justify-center gap-2.5 py-4 text-[13px] uppercase tracking-[0.18em] text-[var(--ink)]">
                <span className="h-2.5 w-2.5 rounded-full" style={{ background: c.dot }} />
                {c.name}
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="reveal mt-14 flex flex-col items-center gap-3">
          <button
            data-testid="lookbook-notify-button"
            onClick={() => open('lookbook')}
            className="btn-primary inline-flex items-center gap-2 px-9 py-4 text-[13px] uppercase tracking-[0.14em]"
          >
            <Bell size={15} />
            Notify me when it drops
          </button>
          <p className="text-[12px] text-[var(--muted-2)] uppercase tracking-[0.14em]">
            Four colors · only 20 made in each
          </p>
        </div>
      </div>
    </section>
  );
};

export default Lookbook;
